import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { CollectStatusListService } from '../../service/collect-status-list/collect-status-list.service';

@Component({
	selector: 'app-collect-status-list',
	templateUrl: './collect-status-list.component.html',
	providers: [
		CollectStatusListService,
		HttpModule
	]
})
export class CollectStatusListComponent implements OnInit {

	private token;
	public collectStatuses: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	collectStatusForm: FormGroup;

	constructor(fb: FormBuilder, private collectStatusListService: CollectStatusListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.collectStatusForm = fb.group({
			'Descricao': '',
			'Status': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchCollectStatus(this.collectStatusForm.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchCollectStatus(this.collectStatusForm.value, this.currentPage, false);
	}

	searchCollectStatus(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.collectStatusListService.searchCollectStatus(this.token, value.Descricao, value.Status, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.collectStatuses = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchCollectStatus(this.collectStatusForm.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/collect-status/component/collect-status-list/collect-status-list.component.ts